import {useContext, useEffect, useState} from 'react';
import {TranslateContext} from "../../../../../context/TranslateContext.jsx";
import {useHistory} from "react-router-dom";
import {LoaderContext} from "../../../../../context/LoaderContext.jsx";
import * as Yup from "yup";
import {
    aggiornaBatchApi,
    aggiornaSchedulazioneApi,
    aggiungiBatchApi, aggiungiSchedulazioneApi, getBatchApi
} from "../../../../../services/SchedulazioniServices";
import {getInstallazioniApi} from "../../../../../services/InstallazioniServices";

export const useFormModificaSchedulazione = ({
                                                 schedulazione,
                                             }) => {


    const [show, setShow] = useState(false);
    const [modalMsg, setModalMsg] = useState(false);
    const [batch, setBatch] = useState([]);
    const [installazioni, setInstallazioni] = useState([]);

    const loader = useContext(LoaderContext);
    const {traduci} = useContext(TranslateContext);

    const history = useHistory();

    const getBatch = async () => {
        loader.startChiamata();
        const response = await getBatchApi();
        setBatch(response.data.data);
        loader.endChiamata();
    }

    const getInstallazioni = async () => {
        loader.startChiamata();
        const response = await getInstallazioniApi();
        setInstallazioni(response.data.data);
        loader.endChiamata();
    }

    useEffect(() => {
        getBatch();
        getInstallazioni();
    }, []);

    const initialFormValues = {
        id_batch: schedulazione?.id_batch?.toString() || '',
        id_installazione: schedulazione?.id_installazione?.toString() || '',
        ora_sched: schedulazione?.ora_sched || '',
        frequenza: schedulazione?.frequenza || '1',
        giorno_settimana: schedulazione?.giorno_settimana || '',
        giorno_mese: schedulazione?.giorno_mese || '',
        mese: schedulazione?.mese || '',
    };

    const validationSchema = Yup.object().shape({
        id_batch: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
        id_installazione: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
        ora_sched: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
        frequenza: Yup.string()
            .required(traduci('Questo campo è obbligatorio')),
    });

    const aggiornaSchedulazione = async (values) => {
        loader.startChiamata();
        const response = await aggiornaSchedulazioneApi(schedulazione.id_schedulazione, values);
        loader.endChiamata();
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    };

    const aggiungiSchedulazione = async (values) => {
        loader.startChiamata();
        const response = await aggiungiSchedulazioneApi(values);
        loader.endChiamata();
        if (response.data.result === 0) {
            history.goBack();
        } else {
            setModalMsg(response.data.description);
            setShow(true);
        }
    };

    const onSubmitForm = (values) => {
        if (schedulazione) {
            aggiornaSchedulazione(values);
        } else {
            aggiungiSchedulazione(values);
        }
    };

    const closeModal = () => setShow(false);

    return {
        initialFormValues,
        validationSchema,
        onSubmitForm,
        show,
        closeModal,
        modalMsg,
        batch,
        installazioni,
    };
};
